import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { Breakpoint } from '@mui/system';
import useMediaQuery from '@mui/system/useMediaQuery';
import useTheme from '@mui/system/useTheme';
import React from 'react';

export interface SectionDividerProps
  extends React.ComponentProps<typeof Divider> {
  children?: React.ReactNode;
  breakpoint?: Breakpoint;
}

export default function SectionDivider({
  breakpoint = 'sm',
  children,
  sx,
  ...props
}: SectionDividerProps) {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up(breakpoint));

  return matches ? (
    <Divider
      component="div"
      role="presentation"
      sx={{ my: 2, ...sx }}
      {...props}
    >
      {children}
    </Divider>
  ) : (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Divider sx={{ my: 2, ...sx }} {...props} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        {children}
      </Box>
      <Divider sx={{ my: 2, ...sx }} {...props} />
    </Box>
  );
}
